import type { Song } from "#app/models/song.ts";
import { deserializeSong, serializeSong } from "#app/utils/serialization.ts";
import Route from "@ember/routing/route";
import { service } from "@ember/service";
import type RouterService from "@ember/routing/router-service";
import type SequencerService from "#services/sequencer.ts";
import type Controller from "@ember/controller";

export interface PlaySongRouteModel {
  song: Song;
}

export default class PlaySongRoute extends Route<PlaySongRouteModel> {
  @service declare router: RouterService;
  @service declare sequencer: SequencerService;

  serialize(model: PlaySongRouteModel) {
    try {
      const songData = serializeSong(model.song);
      return { song_data: songData };
    } catch (error) {
      console.error("problem serializing song to build route link");
      throw error;
    }
  }

  model(params: { song_data: string }) {
    const _songData = params.song_data;

    try {
      // decode the data to get a song
      console.log(`[route:play.song] decoding song_data: ${_songData}`);
      const song: Song = deserializeSong(_songData);
      console.log("[route:play.song] decoded song data", song);
      return { song };
    } catch (error) {
      console.error("[route:play.song] error decoding song data", error);
      this.router.transitionTo("play.error");
      return;
    }
  }

  setupController(controller: Controller, model: PlaySongRouteModel): void {
    super.setupController(controller, model);
    if (model?.song) {
      this.sequencer.loadSong(model.song);
    }
  }
}
